import { styled } from '@mui/material/styles'
import { Button } from '@mui/material'
import { Box } from '@mui/material'

export const ModalWrapper = styled(Box)(() => ({
    padding: '25px',
    textAlign: 'center',
    maxWidth: '280px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
}))

export const ModalTitle = styled(Box)(() => ({
    fontWeight: '500',
    fontSize: '14px',
    fontFamily: 'Inter',
    marginBottom: '15px',
}))

export const ModalText = styled(Box)(({ theme }) => ({
    fontSize: '12px',
    color: theme.palette.text.secondary,
    marginBottom: '20px',
    fontWeight: '400',
}))

export const ConfirmButton = styled(Button)(({ theme }) => ({
    padding: 0,
    textTransform: 'uppercase',
    color: theme.palette.primary.main,
    fontFamily: 'Inter',
    textDecoration: 'underline',
    fontWeight: 500,
    background: 'transparent',
    justifyContent: 'center',
    boxShadow: 'none',
    minWidth: 'auto',
    '&:hover': {
        background: 'transparent',
    }
}))